export default "__VITE_ASSET__DLBD7$_b__"